import { QueryErrorResetBoundary, useMutation } from 'react-query';
import { ErrorBoundary } from 'react-error-boundary';
import { HeadingPages } from '../../../components/HeadingPages';
import { api } from '../../../services/api';
import {
  Table,
  TableContainer,
  Th,
  Thead,
  Tr,
  Tbody,
  useToast,
  Flex,
  Input,
  Button
} from '@chakra-ui/react';
import { Suspense, useEffect } from 'react';
import { Loader } from '../../../components/ComponentLoader/Loader';
import { InfoGerais } from './InfoGerais';
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter';
import { ListaInfos } from './ListaInfos';
import { useForm } from 'react-hook-form';

export async function getChamados(dataInicial, dataFinal) {
  try {
    const response = await api.get(
      `/site/v2/crm-controle/verifica-chamados?data_inicial=${dataInicial}&data_final=${dataFinal}`
    );
    console.log('response', response);
    const data = response?.data?.lista?.map((item) => {
      return {
        ...item,
        data_hora: new Date(item.data_hora).toLocaleString('pt-BR', {
          timeZone: 'America/Sao_Paulo'
        }),
        nome_vendedor: firstLetterUpperCaseAndRestLowerCase(item.nome_vendedor),
        tipo_orcamento: firstLetterUpperCaseAndRestLowerCase(item.tipo_orcamento)
      };
    });

    return {
      ...response.data,
      lista: data
    };
  } catch (error) {
    console.log(error);
  }
}

export function ChamadosVendas() {
  const { handleSubmit, register, setValue } = useForm();

  useEffect(() => {
    const dateNow = new Date();

    const date = dateNow.toISOString().split('T')[0];
    setValue('data_inicial', date);
    setValue('data_final', date);

    getDataVendas({ data_inicial: date, data_final: date });
  }, [setValue]);

  const toast = useToast({
    position: 'top'
  });

  const {
    data: chamado,
    mutateAsync,
    isLoading
  } = useMutation(
    (data) => {
      return getChamados(data.data_inicial, data.data_final);
    },
    {
      refetchOnWindowFocus: true,
      suspense: true,
      optimisticResults: true,
      onError: () => {
        toast({
          title: 'Erro ao carregar os dados',
          status: 'error',
          duration: 3000,
          isClosable: true
        });
      },
      onSuccess: () => {
        toast({
          title: 'Dados carregados com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true
        });
      }
    }
  );

  async function getDataVendas(data) {
    try {
      await mutateAsync(data);
    } catch (error) {
      console.log(error);
    }
  }

  console.log(chamado);
  return (
    <>
      <HeadingPages name="Chamados de Vendas" />

      {isLoading && <Loader />}

      <Flex
        maxW="500px"
        mx="auto"
        w="full"
        my="1rem"
        as="form"
        onSubmit={handleSubmit(getDataVendas)}
        gap={2}>
        <Input type="date" {...register('data_inicial')} />

        <Input type="date" {...register('data_final')} />

        <Button type="submit" maxW="100px" w="full" isLoading={isLoading} loadingText="Carregando">
          Solicitar
        </Button>
      </Flex>

      <Suspense fallback={<Loader />}>
        <TableContainer>
          <Table
            variant="striped"
            colorScheme="facebook"
            width="100%"
            maxWidth={1120}
            marginX="auto"
            marginTop="4"
            size="sm">
            <Thead>
              <Tr>
                <Th textAlign="center">Quantidade de chamados no dia</Th>
                <Th textAlign="center">Chamados do Site</Th>
                <Th textAlign="center">Chamados do WhatsApp</Th>
                <Th textAlign="center">Chamados Atendimento</Th>
                <Th textAlign="center">Clientes Novos</Th>
              </Tr>
            </Thead>

            <QueryErrorResetBoundary>
              {({ reset }) => (
                <ErrorBoundary
                  onReset={reset}
                  fallbackRender={({ resetErrorBoundary }) => (
                    <div>
                      Erro ao carregar os dados{' '}
                      <button onClick={() => resetErrorBoundary()}>Tentar novamente</button>
                    </div>
                  )}>
                  <InfoGerais chamado={chamado} />
                </ErrorBoundary>
              )}
            </QueryErrorResetBoundary>
          </Table>
        </TableContainer>

        <TableContainer mt="2rem" pt="2rem" borderTop="1px solid #cecece">
          <Table>
            <Thead>
              <Tr>
                <Th textAlign="center">Data</Th>
                <Th textAlign="center">Vendedor</Th>
                <Th textAlign="center">Pedido</Th>
                <Th textAlign="center">Tipo</Th>
                <Th textAlign="center">Link pdf</Th>
              </Tr>
            </Thead>

            <QueryErrorResetBoundary>
              {({ reset }) => (
                <ErrorBoundary
                  onReset={reset}
                  fallbackRender={({ resetErrorBoundary }) => (
                    <div>
                      Erro ao carregar os dados{' '}
                      <button onClick={() => resetErrorBoundary()}>Tentar novamente</button>
                    </div>
                  )}>
                  <Tbody>
                    {chamado?.lista?.map((chamado, index) => (
                      <ListaInfos key={index} chamado={chamado} />
                    ))}
                  </Tbody>
                </ErrorBoundary>
              )}
            </QueryErrorResetBoundary>
          </Table>
        </TableContainer>
      </Suspense>
    </>
  );
}
